<script lang="ts" setup>
type Tab = { title: string; slug: string; count: number };

const feedbackStore = useFeedbackStore();
const { reviewsPagination, questionsPagination } = storeToRefs(feedbackStore);

const tabs = computed(() => [
  { title: 'Отзывы', slug: 'reviews', count: reviewsPagination.value?.total ?? 0 },
  { title: 'Вопросы', slug: 'questions', count: questionsPagination.value?.total ?? 0 },
]);

const selectedTab = ref(tabs.value[0]);
const route = useRoute();

async function switchTab(tab: Tab) {
  selectedTab.value = tab;
  await navigateTo({ query: { tab: tab.slug }, hash: '#feedback' });
}

watch(
  () => route.query.tab,
  () => (selectedTab.value = tabs.value.find((tab) => tab.slug === route.query.tab) || tabs.value[0]),
  { immediate: true },
);

const { selectedOffer } = storeToRefs(useCatalogStore());

watch(
  () => selectedOffer.value.product_id,
  (oldValue, newValue) => {
    if (oldValue !== newValue) feedbackStore.$reset();
  },
);
</script>

<template>
  <section class="product-page-feedback-block">
    <div class="product-page-feedback-block__tabs">
      <button
        v-for="tab in tabs"
        :key="tab.slug"
        :class="{ 'product-page-feedback-block__tab--selected': selectedTab.slug === tab.slug }"
        class="product-page-feedback-block__tab"
        @click="switchTab(tab)"
      >
        <h2 class="leading-none">{{ tab.title }}</h2>
        <span class="text-hell-black-60 text-sm sm:text-base !leading-none sm:!leading-tight"> {{ tab.count }}</span>
      </button>
    </div>

    <ProductPageReviewsBlock v-show="selectedTab.slug === 'reviews'" />
    <ProductPageQuestionsBlock v-show="selectedTab.slug === 'questions'" />
  </section>
</template>

<style lang="scss" scoped>
.product-page-feedback-block {
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;

  &__tabs {
    display: flex;
  }

  &__tab {
    display: flex;
    gap: 8px;
    justify-content: center;
    align-items: end;
    padding: 12px 16px;
    border-bottom: 2px solid $hell-black-20;
    color: $hell-black-60;
    transition: all 0.2s;

    &:hover {
      border-color: $hell-black-40;
      color: $hell-black-80;
    }

    &--selected {
      border-color: $hell-black;
      color: $hell-black;
    }
  }
}
</style>
